import Button from 'components/button'
import { SizableText, XStack, YStack } from 'tamagui'
import { CheckItem } from '../CheckItem'
import { useOnboarding } from '../OnboardingContext'

export default function Form6Guide() {
    const { progress, setCurrentStep, refetchProgress, startStepTour } = useOnboarding()

    const hasForm6Created = progress?.hasForm6Created ?? false
    const hasForm6Sent = progress?.hasForm6Sent ?? false
    const hasWishlistFilled = progress?.hasWishlistFilled ?? false
    const firstPurchaserId = progress?.firstPurchaserId

    return (
        <YStack gap="$4">
            <SizableText size="$6" fontWeight="700">
                Send Your First Form 6
            </SizableText>
            <SizableText size="$3" color="$colorSoft">
                Now send a Form 6 (Agent Appointment) to the client you just created. This establishes the legal agency relationship.
            </SizableText>

            {/* Instructions */}
            <YStack gap="$2" padding="$3" backgroundColor="$backgroundStrong" borderRadius={14} borderWidth={1} borderColor="$borderColor">
                <SizableText size="$2" fontWeight="600" color="$colorSoft" marginBottom="$1">
                    Steps:
                </SizableText>
                <XStack gap="$2" alignItems="flex-start">
                    <SizableText size="$3" color="$colorMuted" width={20}>1.</SizableText>
                    <SizableText size="$3" color="$colorSoft" flex={1}>
                        Open your client and click Edit to switch to edit mode
                    </SizableText>
                </XStack>
                <XStack gap="$2" alignItems="flex-start">
                    <SizableText size="$3" color="$colorMuted" width={20}>2.</SizableText>
                    <SizableText size="$3" color="$colorSoft" flex={1}>
                        Enter an authority start date and duration
                    </SizableText>
                </XStack>
                <XStack gap="$2" alignItems="flex-start">
                    <SizableText size="$3" color="$colorMuted" width={20}>3.</SizableText>
                    <SizableText size="$3" color="$colorSoft" flex={1}>
                        Scroll down and click "Create Form" — fields are auto-filled from your org details
                    </SizableText>
                </XStack>
                <XStack gap="$2" alignItems="flex-start">
                    <SizableText size="$3" color="$colorMuted" width={20}>4.</SizableText>
                    <SizableText size="$3" color="$colorSoft" flex={1}>
                        Review the pre-filled form, then click "Send"
                    </SizableText>
                </XStack>
                <XStack gap="$2" alignItems="flex-start">
                    <SizableText size="$3" color="$colorMuted" width={20}>5.</SizableText>
                    <SizableText size="$3" color="$colorSoft" flex={1}>
                        Both you and the client will receive signing requests via email
                    </SizableText>
                </XStack>
            </YStack>

            {/* Progress */}
            <YStack gap="$2" padding="$3" backgroundColor="$backgroundStrong" borderRadius={14} borderWidth={1} borderColor="$borderColor">
                <CheckItem checked={hasForm6Created} label="Create a Form 6" />
                <CheckItem checked={hasForm6Sent} label="Send the Form 6 for signing" />
            </YStack>

            {firstPurchaserId && !hasForm6Sent ? (
                <Button
                    size="$4"
                    theme="primary"
                    onPress={() => startStepTour('form6')}
                >
                    Show me
                </Button>
            ) : !firstPurchaserId && !hasWishlistFilled ? (
                <YStack gap="$2">
                    <Button
                        size="$4"
                        theme="primary"
                        disabled
                        opacity={0.5}
                    >
                        Show me
                    </Button>
                    <SizableText size="$2" color="$colorMuted">
                        Complete the wishlist step first.
                    </SizableText>
                </YStack>
            ) : null}

            {!hasForm6Sent && hasForm6Created && (
                <Button size="$3" variant="outlined" onPress={() => refetchProgress()}>
                    Refresh Status
                </Button>
            )}

            {hasForm6Sent && (
                <Button
                    size="$3"
                    variant="outlined"
                    onPress={() => setCurrentStep(5)}
                >
                    Next step
                </Button>
            )}
        </YStack>
    )
}
